
export default function CTASection() {
  return (
    <section 
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/33ce782b7067e0f8e85a1390116a3e61.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          今すぐビジネスを次のレベルへ
        </h2>
        <div className="text-xl text-white max-w-3xl mx-auto text-left md:text-center">
          <p className="mb-2 leading-tight">
            無料相談で、あなたのビジネス課題を詳しくお聞きし、
          </p>
          <p className="leading-tight">
            最適なマーケティング戦略をご提案いたします。
          </p>
        </div>
      </div>
    </section>
  );
}
